
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTrendUp as ObiTrendUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-trend-up.js';
 
 
 

 
 export const ObiTrendUp = createComponent({
   react: React,
   tagName: 'obi-trend-up',
   elementClass: ObiTrendUpElement,
   events: {
     
   }
  });
 
 